// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { LearningResourceInfo } from './learning-resource-info';

/**
 * 
 * @export
 * @interface ContractEdit
 */
export interface ContractEdit {
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    type: ContractEditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    companyId: string;
    /**
     * **Deprecated.**
     * @type {string}
     * @memberof ContractEdit
     */
    clientType?: string;
    /**
     * **Deprecated.**
     * @type {string}
     * @memberof ContractEdit
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    responsibleId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    contractorId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    agentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    conditionId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractEdit
     */
    userIds?: Array<string>;
    /**
     * 
     * @type {Array<LearningResourceInfo>}
     * @memberof ContractEdit
     */
    learningResources?: Array<LearningResourceInfo>;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    paymentConditions: string;
    /**
     * 
     * @type {number}
     * @memberof ContractEdit
     */
    nds?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractEdit
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractEdit
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ContractEdit
     */
    signedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractEdit
     */
    formedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum ContractEditTypeEnum {
    Contract = 'contract',
    Annex = 'annex'
}



